import React from "react";
import { Container } from "@chakra-ui/react";
import PromotionList from "./components/PromotionList";

export default function Promotion() {
    return (
        <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
            <PromotionList />
        </Container>
    );
}
